import {remCalc} from '../../_utils'

export default {
    baseStyle: {
        container: {
            display: 'flex',
            flexDirection: 'column',
            width: '100%',
            paddingY: {base: remCalc(16), lg: remCalc(24)},
            paddingX: remCalc(16),
            gap: {base: remCalc(16), lg: remCalc(0)},
            _focus: {
                outline: 'none !important',
                boxShadow: 'none !important',
            },
            _focusVisible: {
                outline: '2px solid !important',
                outlineColor: 'blue.500 !important',
                outlineOffset: '-3px !important',
                boxShadow: 'none !important',
            },
            borderRadius: 'large',
        },
        contentWrapper: {
            display: 'flex',
            flexDirection: 'row',
            justifyContent: 'space-between',
            alignItems: 'flex-start',
            width: '100%',
            gap: remCalc(16),
        },
        detailsColumn: {
            gap: remCalc(4),
            justifyContent: 'center',
            alignItems: 'flex-start',
            w: '100%',
        },
        buttonColumn: {
            justifyContent: 'center',
            alignItems: 'center',
            marginTop: remCalc(0),
        },
        mobileSelectButton: {
            width: '100%',
        },
        addressContainer: {
            display: 'flex',
            flexDirection: 'column',
            textStyle: 'body-small',
            color: 'foreground.neutral.default',
        },
        // Pickup name
        name: {
            textStyle: 'head-xsmall',
            color: 'foreground.neutral.default',
            fontWeight: 'medium',
        },
        // Opening hours
        hours: {
            textStyle: 'body-small',
            color: 'foreground.neutral.subtle',
        },
        hoursTitle: {
            textStyle: 'body-small',
            color: 'foreground.neutral.subtle',
        },
        // Button
        selectButton: {
            minWidth: remCalc(140),
            textStyle: 'body-medium',
        },
        accordionPanel: {
            marginTop: remCalc(8),
            padding: remCalc(0),
        },
        openingHoursButton: {
            width: 'fit-content',
            px: 0,
            _hover: {bg: 'transparent'},
        },
    },
}
